module.exports = __webpack_public_path__ + "img/makinormalohnehintergrund.b33f70b2.png";